<template>
  <div>
    <template v-if="getMerchant().merchant_type == 'ticket'">
      <TicketNewCart v-if="getMerchant().is_special_merchant"></TicketNewCart>
      <ticket-cart v-else></ticket-cart>
    </template>
    <RestaurantCart v-if="getMerchant().merchant_type == 'restaurant'"></RestaurantCart>
    <HotelBe v-if="getMerchant().merchant_type == 'hotel'"></HotelBe>
  </div>
</template>
<script>
import TicketCart from "@/pages/ticket/Cart";
import TicketNewCart from '@/pages/ticket/TicketCart'
import RestaurantCart from "@/pages/restaurant/Cart";
import HotelBe from '@/pages/hotel/be/BeCartBase'
import { mapGetters } from "vuex";

export default {
  components: {
    TicketCart,
    RestaurantCart,
    HotelBe,
    TicketNewCart
  },
  metaInfo(){
    return {
      title: 'Cart',
      titleTemplate: this.getMetaTitleTemplate()
    }
  },
  computed:{
    is_mobile_view(){
      return window.innerWidth > 768 ? false : true
    }
  },
  methods: {
    ...mapGetters(["getMerchant",'getMetaTitleTemplate']),
  },
  mounted(){
    if(this.getMerchant().merchant_type == 'restaurant' && this.getMerchant().is_preview_only){
      this.$router.push({
        name: "MerchantHome"
      })
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/general/Cart.vue